<template lang="pug">
  v-card
    v-container(fluid).pa-2.action-header
      v-layout(row wrap)
        v-flex(xs4)
          v-btn(flat small to="/contacts" color="primary").ma-0.px-1.action-btn
            v-icon(small color="primary") chevron_left
            span.action Back to Contacts
        v-flex(xs8).align-end
          v-btn(
            flat
            small
            color="primary"
            :disabled="disablePrev"
            @click="handleContactSwitch(-1)"
          ).ma-0.pa-0.action-btn
            v-icon(small color="primary") chevron_left
            span.action Prev
          v-btn(
            flat
            small
            color="primary"
            :disabled="disableNext"
            @click="handleContactSwitch(1)"
          ).ma-0.pa-0.action-btn
            span.action Next
            v-icon(small color="primary") chevron_right
      v-layout(column).pa-0.mt-4
        v-layout(align-center)
          liondesk-avatar.pr-2(
            :color="getContactName | getInitials | generateRandomColor('dark')"
            :text="getContactName | getInitials"
            text-classes="white--text"
            text-styles="font-size: 15px;"
            size="48px"
          )
          v-flex(xs10)
            v-layout(column)
              div.height-24(v-if="!editing")
                span.title {{contactHasName ?  getContactName : '(Unnamed Contact)'}}
                v-btn(icon small flat color="primary" @click="resetName").my-0
                  v-icon(small) edit
              div(v-else).display-inline
                v-form(v-model="newNameValid" ref="newNameForm" lazy-validation)
                  v-text-field.ma-0.pa-0(
                    placeholder="Update contact Name"
                    v-model="newName"
                    :rules="[newNameRules.required, newNameRules.minLength(newNameMinLegth), newNameRules.onlyAllowedCharacters, newNameRules.denySpecificWords(newNameProhibitedWords)]"
                  )
                v-btn(icon small flat color="primary"  @click="handleChangeName" :disabled="!newNameValid")
                  v-icon(small) save
                v-btn(icon small flat color="primary" @click="resetName")
                  v-icon(small) cancel
              v-layout(row align-center justify-space-between wrap)
                hotness(
                  v-if="currentContact.hotness_id"
                  :name="currentContact.hotness.name"
                  :color="currentContact.hotness.color"
                  :max-length-name="24"
                )
                span.subtitle {{lastActivity}}
        bulk-action(
          is-profile-v2
          should-redirect
          :query="{}"
          :selected-ids="[currentContact.id]"
          :selected-contacts="[currentContact]"
          @contact-updated="$emit('contact-updated')"
          @showChatDrawer="$emit('showChatDrawer', $event)"
          @openEmailDrawer="$emit('openEmailDrawer')"
          @openEventDrawer="$emit('openEventDrawer')"
          @refresh-events="$emit('refresh-events')"
        )
        v-layout.disabled-alternate.search-layout(row wrap)
          tags-picker.contact-tags(
            v-model="contactTags"
            is-profile-v2
            :tags-list="tagsList"
            :disabled="false"
            :max-length-name="24"
            @input="tagsChange"
            @update:searchInput="$emit('find-tags')"
            @save:tag="$emit('create-tag')"
          )
</template>

<script>
import { mapActions } from 'vuex';
import LiondeskAvatar from '@/Core/components/LiondeskAvatar';
import generateRandomColor from '@/Core/utilities/randomColorGenerator';
import getInitials from '@/Core/filters/getInitials';
import BulkAction from '../BulkAction';
import Hotness from '../Hotness';
import TagsPicker from '@/Core/components/TagsPicker';
import {FIRST_NAME_MIN_LENGTH, FIRST_NAME_RULES, FIRST_NAME_PROHIBITED_WORDS} from '../../config/contact-fields-rules'

export default {
  name: 'ActionCard',
  components: {
    LiondeskAvatar,
    BulkAction,
    Hotness,
    TagsPicker,
  },
  filters: {
    generateRandomColor,
    getInitials,
  },
  props: {
    contacts: {
      default: [],
    },
    currentContact: {
      default: {},
    },
    lastActivity: {
      default: '',
    },
    tagsList: {
      default: [],
    },
    selectedTags: {
      default: []
    }
  },
  data() {
    return {
      editing: false,
      newName: '',
      newNameValid: true,
      newNameMinLegth: FIRST_NAME_MIN_LENGTH,
      newNameProhibitedWords: FIRST_NAME_PROHIBITED_WORDS,
      newNameRules: FIRST_NAME_RULES,
      contactTags: this.selectedTags,
    }
  },
   created() {
    if (!this.contacts || this.contacts.length === 0) {
      this.findContacts();
    }
  },
  mounted() {
    this.$emit('resize');
  },
  watch: {
    selectedTags(newValue, oldValue) {
      this.contactTags = newValue
    },
    contactTags(newValue) {
      if (this.selectedTags.join(',') != newValue.join(',')) {
        this.$emit('set-new-tags', newValue);
      }
    },
  },
  computed: {
    disableNext() {
      if (!this.contacts.length) return true;
      return this.contactIndex === this.contacts.length - 1;
    },
    disablePrev() {
      if (!this.contacts.length) return true;
      return !this.contactIndex;
    },
    contactIndex() {
      return this.contacts.findIndex(contact => {
        return contact.id === this.currentContact.id;
      });
    },
    getContactName() {
      return `${this.currentContact.first_name || '' } ${this.currentContact.last_name || '' }`;
    },
    contactHasName() {
      return this.currentContact.first_name || this.currentContact.last_name;
    }
  },
  methods: {
    ...mapActions('contactsTable', ['findContacts']),
    handleContactSwitch(direction) {
      const nextContact = this.contacts[this.contactIndex + direction];
      this.$router.push({ name: 'contact-profile', params: { id: nextContact.id } });
    },
    resetName() {
      if (this.$refs.newNameForm) this.$refs.newNameForm.resetValidation();
      this.editing = !this.editing;
      this.newName = this.getContactName;
    },
    async handleChangeName() {
      if (!this.$refs.newNameForm.validate()) return;
      const FIRST_NAME_FIELD = 'first_name';
      const LAST_NAME_FIELD = 'last_name';
      if (this.newName) {
        const splitName = this.newName.trim().split(' ');
        this.currentContact.first_name = splitName[0];
        if (splitName.length > 1) {
          splitName.shift();
          this.currentContact.last_name = splitName.join(' ');
        } else {
          this.currentContact.last_name = '';
        }
      } else {
        this.currentContact.last_name = '';
        this.currentContact.first_name = '';
      }
      this.$emit('add-to-patched-fields', this.currentContact.first_name, FIRST_NAME_FIELD);
      this.$emit('add-to-patched-fields', this.currentContact.last_name, LAST_NAME_FIELD);
      this.editing = false;
      this.$emit('save-contact');
    },
    tagsChange() {
      this.$emit('save-tags', this.contactTags.join(','));
    }
  }
};
</script>
<style lang="scss" scoped>
.action {
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.37px;
}
.title {
  color: #000000;
  font-size: 18px;
  letter-spacing: 0.66px;
}
.subtitle {
  color: var(--v-primary-base);
  font-size: 11px;
  letter-spacing: -0.07px;
  padding-right: 3%;
}

.display-inline {
  min-height: 40px;
  display: flex;
}

.action-btn {
  text-transform: capitalize;
  font-weight: initial;
  font-size: inherit;
}

.align-end {
  text-align: end;
}
</style>
